/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".find-ssn[_ngcontent-%COMP%]{width:6rem;padding:0 .5rem;height:calc(100% - 16px)}.bottom-btns[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:48%}"];
export { styles as styles };
